import { changeField, setStep } from "../../redux/payment/slice";
import { PAYMENT_STEPS } from "../../types/PaymentMethodsTypes";

export const noActionIdmHandler = (dispatch, statusCode, data) => {
  if (statusCode === 200 || statusCode === 201) {
    const { bankName, bankAccount, fullName } = data;
    if (bankName) {
      dispatch(changeField({ field: "bankName", value: bankName }));
    }
    if (bankName) {
      dispatch(changeField({ field: "accountNumber", value: bankAccount }));
    }
    if (bankName) {
      dispatch(changeField({ field: "name", value: fullName }));
    }
    dispatch(setStep(PAYMENT_STEPS.PENDING_SUCCESS));
  } else {
    dispatch(setStep(PAYMENT_STEPS.FAILED));
  }
};
